import Loadable from 'react-loadable';

import { LoadingMessage } from '../widgets/loading-message';

export const AddEmployeeDialog = Loadable({
  loader: () => import('./profile/add-employee-dialog'),
  loading: () => null,
});

export const EmployeeEndDateDialog = Loadable({
  loader: () => import('./employee-end-date-dialog'),
  loading: LoadingMessage,
});
